import * as pubsub from "pubsub-js";
import { ServiceTicketListItem } from "client/Api/Workspace/LiveInformation/ConnectWise/connectWiseLiveInformation";

enum ConnectWiseEvent {
	// When 1 ticket was created
	Created = "connectwise.created",
}

type Data<T extends ConnectWiseEvent> =
	T extends ConnectWiseEvent.Created ? ServiceTicketListItem :
	never;

export const subscribe: <T extends ConnectWiseEvent>(kind: T, callback: (message: string, data: Data<T>) => void) => PubSubSubscriptionToken = pubsub.subscribe;
export const publish: <T extends ConnectWiseEvent>(kind: T, data: Data<T>) => void = pubsub.publish;
export const unsubscribe: (token: PubSubSubscriptionToken) => void = pubsub.unsubscribe;
export {
	ConnectWiseEvent
};
